import { Avatar, Divider, List, ListItem, ListItemAvatar, ListItemText } from "@mui/material";
import * as React from "react";
import { useState } from "react";
import { connect } from 'react-redux';
import { updateState } from "../store/RegistrationModal";
import { Person as PersonIcon, Business as BusinessIcon } from '@mui/icons-material';
import CompanyProfileAddEdit from "../../../pages/BiddingProfile/CompanyProfileAddEdit";
import IndividualProfileAddEdit from "../../../pages/BiddingProfile/IndividualProfileAddEdit";
import FooterButtons from "./FooterButtons";

interface ProfileAddProps {
    onClose: () => void;
    onNextStep: () => void;
    onBackStep: () => void;
    settings: any,
    state: any,
    updateState: (data: any) => void
}

export const ProfileAdd: React.FC<ProfileAddProps> = props => {
    const { onClose, onNextStep, onBackStep, state, updateState } = props;

    const [profileType, setProfileType] = useState<any>('company');

    const handleOnClose = () => {
        //Custom logic
        onClose();
    }

    const handleBack = () => {
        //Custom logic
        onBackStep();
    }

    const handleSubmit = (data?: any) => {
        //Custom logic
        updateState({ setSelectedProfileId: data?.id, resetProfiles: true })
        onNextStep();
    }

    const renderFooter = (onClose?: () => void, onBack?: () => void, onSubmit?: () => void) => <FooterButtons onClose={onClose} onBack={onBack} onSubmit={onSubmit} />

    return <div className={"pb-reg-step" + (profileType ? " pb-reg-step--wide" : "")}>
        <div className="pb-reg-step-title">{profileType === 'company' ? "Adding New Company Profile" : profileType === "individual" ? "Adding New Individual Profile" : "Add New Profile"}</div>
        {!profileType ? <>
            <p>What type of profile would you like to add?</p>
            <div className="pb-reg-options">
                <button type="button" className="pb-reg-option" onClick={() => setProfileType("company")}>
                    <span className="pb-reg-option-icon"><BusinessIcon /></span>
                    Company
                </button>
                <button type="button" className="pb-reg-option" onClick={() => setProfileType("individual")}>
                    <span className="pb-reg-option-icon"><PersonIcon /></span>
                    Individual
                </button>
            </div>
        </> : profileType === 'company' ? <CompanyProfileAddEdit
            renderSpaceAtTop={false}
            overrideButtonSection={renderFooter}
            onCloseCallback={handleOnClose}
            onBackCallback={handleBack}
            onSubmitCallback={handleSubmit}
            scrollToTop={false}
            registrationProcess={true}
        /> : <IndividualProfileAddEdit
            renderSpaceAtTop={false}
            overrideButtonSection={renderFooter}
            onCloseCallback={handleOnClose}
            onBackCallback={handleBack}
            onSubmitCallback={handleSubmit}
            registrationProcess={true}
        />}
        {!profileType && <FooterButtons onClose={handleOnClose} onBack={handleBack} />}
    </div>
};

const mapStateToProps = (state: any) => ({
    settings: state.settings.settings,
    state: state.biddingRegistrationModal
})


const mapDispatchToProps = (dispatch: any) => {
    return {
        updateState: (data: any) => dispatch(updateState(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileAdd)